import { Component, OnInit } from '@angular/core';
import { LessonStatus } from '@app/definitions/interfaces';

@Component({
    selector: 'app-profile-analytics',
    templateUrl: './profile-analytics.component.html',
    styleUrls: ['./profile-analytics.component.scss']
})
export class ProfileAnalyticsComponent implements OnInit {
    lesson_statuses = LessonStatus;

    constructor() {}

    ngOnInit() {}
}
